import { isEmpty } from '@/common/utils/Util';

export default {
  setDetail: (state, data) => {
    state.detail = data;
  },
  setNotificationList: (state, list) => {
    if (isEmpty(state.notificationList)) {
      state.notificationList = list;
    } else {
      state.notificationList = [...state.notificationList, ...list];
    }
  },
  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },
  setPageInfo: (state, info) => {
    Object.assign(state.pageInfo, info);
  },
  initPage: state => {
    state.condition.page = 1;
    state.condition.limit = 10;
    state.condition.userNo = '';
    state.notificationList = [];
  },
  setUnreadCount: (state, count) => {
    state.unreadCount = Number.isFinite(count) ? count : 0;
  },
  // 260521: 알림 클릭 시 클라 list state에 즉시 read 마킹 (옵티미스틱 UI).
  // NotificationCard가 `item?.id` truthy면 opacity30 처리 → -1 sentinel로 truthy 유지.
  markListItemRead: (state, notificationNo) => {
    if (!Array.isArray(state.notificationList)) return;
    const item = state.notificationList.find(n => n.notificationNo === notificationNo);
    if (item && !item.id) item.id = -1;
  }
};
